import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { form_control, SaveReportFile } from "projects/sepidz-web-framework/src/lib/models";
import { BaseFormComponent } from "projects//sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";

@Component({
  selector: "report-copy",
  templateUrl: "./report-copy.component.html",
  styleUrls: ["./report-copy.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportCopyComponent extends BaseFormComponent<SaveReportFile> {
  @Input() dataList: SaveReportFile[] = [];
  hasManageAccess = false;
  samePermission: boolean = false;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    super.ngOnInit();
  }
  async setColumns() {
    this.samePermission = this.apiName.split("/").length > 1;
    this.columns = [];
    this.columns.push(<form_control>{
      label: "انتخاب گزارش",
      controlType: FormControlTypes.textbox,
      modelName: "ReportTitle",
      disabled: false,
      name: "ReportTitle",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
    });
    this.orignalColumns = this.columns;
    this.setFormGroup(this.model);
  }
  async save() {
    this.result = this.formGroup.value;
    this.closeModal();
  }
}
